// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__20Xc6","inner":"Footer_inner__1T0uj"};